/*
 * Copyright (c) 2020. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <https://veneliniliev.com>
 */

import { environment } from '@env/environment';

export enum CommentsTypes {
  note = environment.enums.types.commentNote,
}
